import React from 'react'
import PropTypes from 'prop-types'
import {Query as ApolloQuery} from 'react-apollo'
import get from 'lodash.get'
import {Spin} from 'antd'
import {CloseCircleFilled} from '@ant-design/icons'

import useRaygun from 'shared/hooks/useRaygun'
import './index.scss'

const Query = ({children, inlineLoading, inlineError, ...props}) => {
  const raygun = useRaygun()

  return (
    <ApolloQuery {...props}>
      {(result) => {
        if (result.loading && inlineLoading) {
          return (
            <div className="query-loading">
              <Spin />
            </div>
          )
        }

        if (result.error && inlineError) {
          console.log(result.error)
          if (raygun) {
            raygun('send', result.error)
          }
          return (
            <div className="query-error">
              <div className="error-content">
                <span className="error-icon">
                  <CloseCircleFilled />
                </span>
                <span className="error-text">
                  Noe gikk galt!
                </span>
                <span className="description-text">
                  En feil har oppstått og innholdet her kan ikke lastes inn.
                  Last siden på nytt og førsøk på nytt. Vennligst kontakt EFKT om
                  problemet vedvarer.
                </span>
              </div>
            </div>
          )
        }

        const getData = (prop, defaultValue = null) =>
          get(result.data, prop, defaultValue)

        return children({...result, getData})
      }}
    </ApolloQuery>
  )
}

Query.propTypes = {
  inlineLoading: PropTypes.bool,
  inlineError: PropTypes.bool,
}

Query.defaultProps = {
  inlineLoading: false,
  inlineError: false,
}

export default Query
